"use client";
import React from "react";

export default function GoogleMap({ address }: { address: string }) {
  const encoded = encodeURIComponent(address);
  const src = `https://www.google.com/maps?q=${encoded}&output=embed`;

  return (
    <div className="w-full h-48 rounded-md overflow-hidden shadow">
      <iframe
        title="map"
        src={src}
        className="w-full h-full"
        loading="lazy"
        allowFullScreen
      />
    </div>
  );
}
